import { IAttrValue } from "@multiweb/types/contracts";
import { CancellationToken } from "@multiweb/types/multiweb";
import { ConditionParams } from "Global/Base/DataSources/Interfaces";
import { IComparable } from "Global/Base/IComparable";
import { IOWObject } from "./IOWObject";

export interface IOWObjectList extends IAttrValue, IComparable {
    className: string;
    updateCondition: string;
    condition: string;
    filterCondition: string;
    conditionParams: ConditionParams;
    readVersioned: boolean | undefined;
    items: Array<IOWObjectListItem>;
    add(param: { className?: string; id?: string; instanceId?: string }): void;
    add(param: IOWObject): void;
    compare(value: any): boolean;
    toJSON(): any;
    containsID(id: string): boolean;
    containsInstanceID(instanceID: string): boolean;
    getObjects(cancellationToken?: CancellationToken): Promise<IOWObject[]>;
    getObject(index: number): Promise<IOWObject>;
    getItemByID(id: string): Promise<IOWObject>;
    getItemByInstanceID(instanceID: string): Promise<IOWObject>;
    getItemInstanceID(index: number): string;
    getItemObjectName(index: number): string;
    getItemID(index: number): string;
    deleteByInstanceID(instanceID: string): Promise<void>;
    deleteById(id: string): Promise<void>;
    clear(): void;
    delete(index: number): void;
}

export class IOWObjectList {
    private static _properties = [
        "className", "updateCondition", "condition", "filterCondition", "conditionParams", "readVersioned", "items",
    ];

    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null && typeof instance === "object" && !this._properties.some((value) => !Reflect.has(instance, value));
    }
}

export interface IOWObjectListItem {
    readonly id: string;
    objectName: string;
    readonly instanceID: string | null;
    compare(item: IOWObjectListItem): boolean;

    getObject(): Promise<IOWObject>;
}
